import { FC, memo, ReactElement } from 'react';
import Loading from 'components/loading/loading';
import './loading-overlay.scss';

const LoadingOverlay: FC = (): ReactElement => (
  <div className="loading-overlay" data-testid="loading-overlay">
    <div className="loading-overlay__container">
      <Loading />
    </div>
  </div>
);

export default memo(LoadingOverlay);
